module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"text":"Her er din daglige vanetrening med et nytt scenario i"},"en":{"text":"Here\u0027s your daily habit training with a new scenario in"}}')
  delete Component.options._Ctor
}
